import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";
import { useDispatch } from "react-redux";

import { errorType } from "../../common/AppConstant";
import { fetchSignOut } from "../../store/AuthStore";

import useStyles from "./useStyles";

/**
 * エラーダイアログコンポーネント.
 *
 * @param {object} errorObject エラーオブジェクト
 * @return {object} コンポーネント
 */
function ErrorDialog(props) {
  // 引数
  const {
    // エラーオブジェクト
    errorObject,
  } = props;

  // スタイル
  const styles = useStyles();

  // Dispatch
  const dispatch = useDispatch();

  // ダイアログクローズ時の処理
  const handleClose = (type) => {
    switch (type) {
      case errorType.authError:
        dispatch(fetchSignOut());
        break;
      case errorType.networkError:
      case errorType.systemError:
      default:
        window.location.reload();
    }
  };

  return (
    <Dialog
      open={Boolean(errorObject && errorObject.type && errorObject.message)}
      fullWidth
      maxWidth="sm"
      onClose={() => handleClose(errorObject.type)}
    >
      <DialogTitle>エラー</DialogTitle>
      <DialogContent className={styles.dialogContent}>
        {errorObject && errorObject.message ? errorObject.message : ""}
      </DialogContent>
      <DialogActions className={styles.dialogActions}>
        <Button color="primary" onClick={() => handleClose(errorObject.type)}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ErrorDialog.propTypes = {
  errorObject: PropTypes.exact({
    type: PropTypes.string,
    message: PropTypes.string,
  }).isRequired,
};

export default ErrorDialog;
